import { render, staticRenderFns } from "./shop-product-grade.vue?vue&type=template&id=12be7aae&scoped=true&"
import script from "./shop-product-grade.vue?vue&type=script&lang=js&"
export * from "./shop-product-grade.vue?vue&type=script&lang=js&"
import style0 from "./shop-product-grade.vue?vue&type=style&index=0&id=12be7aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12be7aae",
  null
  
)

export default component.exports